import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import { nonAccentVietnamese } from '@app/utils/utils';
import _kidGroupApis from '@app/apis/foodkid/kidGroup.api';

/** Helper: đảm bảo value luôn là array cho mode="multiple" */
const toArray = (v) => {
    if (Array.isArray(v)) return v;
    if (v) return [v];
    return [];
};

const KidGroupMultiSelect = ({
    oId,
    label = null,
    defaultValue,
    onChange,
    disabled = false,
}) => {
    const [list, setList] = useState([]);
    const [selectId, setSelectId] = useState([]);

    // ── Fetch danh sách nhóm trẻ khi oId thay đổi ──
    useEffect(() => {
        if (!oId || oId === '0') return;

        let cancelled = false;

        _kidGroupApis.getListByOId(oId).then(({ status, data }) => {
            if (cancelled) return;

            if (status !== 200 || !data?.data?.length) {
                setList([]);
                setSelectId([]);
                return;
            }

            const dataRes = data.data;
            const defaultArr = toArray(defaultValue);
            const matched =
                defaultArr.length > 0 &&
                defaultArr.every((v) =>
                    dataRes.some((item) => item.kg_id === v),
                );

            const id = matched ? defaultArr : [dataRes[0].kg_id];

            setList(dataRes);
            setSelectId(id);
            onChange?.(id);
        });

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [oId]);

    // ── Đồng bộ khi defaultValue thay đổi từ bên ngoài ──
    useEffect(() => {
        if (defaultValue) {
            setSelectId(toArray(defaultValue));
        } else if (list.length > 0) {
            setSelectId([list[0].kg_id]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValue]);

    // ── Filter tìm kiếm tiếng Việt không dấu ──
    const filterOption = useCallback((input, option) => {
        if (!option?.children) return false;
        const normalizedOption = nonAccentVietnamese(
            option.children.replace(/\s/g, ''),
        ).toLowerCase();
        const normalizedInput = nonAccentVietnamese(
            input.replace(/\s/g, ''),
        ).toLowerCase();
        return normalizedOption.includes(normalizedInput);
    }, []);

    // ── Options memo ──
    const options = useMemo(
        () =>
            list.map((item) => (
                <Select.Option value={item.kg_id} key={item.kg_id}>
                    {item.kg_name}
                </Select.Option>
            )),
        [list],
    );

    const handleChange = useCallback(
        (value) => {
            setSelectId(value);
            onChange?.(value);
        },
        [onChange],
    );

    return (
        <>
            {label && (
                <label>
                    <h6 className="panel-title">{label}</h6>
                </label>
            )}
            <Select
                mode="multiple"
                value={selectId}
                optionFilterProp="children"
                filterOption={filterOption}
                disabled={disabled}
                className="disable-modified"
                onChange={handleChange}
            >
                {options}
            </Select>
        </>
    );
};

export default KidGroupMultiSelect;
